import GbiContent from "./gbi/index";


export function GbiChat(props){
    return  <GbiContent {...props}  />
}

export function AAA(){

}

export default {
    'gbichat': GbiChat
}